import { render } from "./WeaponsView.vue?vue&type=template&id=23e573ff&scoped=true"
import script from "./WeaponsView.vue?vue&type=script&lang=js"
export * from "./WeaponsView.vue?vue&type=script&lang=js"

import "./WeaponsView.vue?vue&type=style&index=0&id=23e573ff&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23e573ff"]])

export default __exports__